import React, {useState} from "react";
import AhtapotPlans from "../ui/AhtapotPlans";
import AhtapotWarningTextBox from "./AhtapotWarningTextBox";
import AhtapotTextBox from "./AhtapotTextBox";


const AhtapotCalculationPanel = (props) => {
    const [selectedEnumValue, setSelectedEnumValue] = useState(null);

    return (<div className="ahtabotPanel">
        <h4 className="text-center font-weight-bold" style={{color: 'darkblue'}}> {"3 Aylık Tanışma Paketi"} </h4>
        <hr/>
        <AhtapotPlans type="3AYLIK" ahtapotPeriodDto={props?.viewDto?.ahtapotThreeMonthDto}
                      enableCheckBoxIcon={false}
                      selectedId={selectedEnumValue}
                      setSelectedEnumValue={setSelectedEnumValue}/>
        <h4 className="text-center font-weight-bold"
            style={{color: 'darkblue'}}> {"İndirimli Yıllık Paket"} </h4>
        <hr/>
        <AhtapotPlans type="YILLIK" ahtapotPeriodDto={props?.viewDto?.ahtapotOneYearDto}
                      enableCheckBoxIcon={false}
                      selectedId={selectedEnumValue}
                      setSelectedEnumValue={setSelectedEnumValue}/>
        <AhtapotWarningTextBox/>
        <AhtapotTextBox/>
    </div>)
};

export default AhtapotCalculationPanel;